import React, { Fragment } from "react";

import PagesErrorBlocked from "../../example-components/PagesErrorBlocked";
export default function PagesError505() {
  return (
    <Fragment>
      <PagesErrorBlocked />
    </Fragment>
  );
}
